/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { clearCache } from '../fn/load-testing/clear-cache';
import { ClearCache$Params } from '../fn/load-testing/clear-cache';

@Injectable({ providedIn: 'root' })
export class LoadTestingService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `clearCache()` */
  static readonly ClearCachePath = '/api/lt/clear-cache';

  /**
   * Clear Cache.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clearCache()` instead.
   *
   * This method doesn't expect any request body.
   */
  clearCache$Response(params?: ClearCache$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return clearCache(this.http, this.rootUrl, params, context);
  }

  /**
   * Clear Cache.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clearCache$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clearCache(params?: ClearCache$Params, context?: HttpContext): Observable<void> {
    return this.clearCache$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
